<template>
  <div class="animated fadeIn">
    <div class="my-5">
      <div class="display-4 font-3xl text-center">
        <span v-if="sampleType"
          >Please describe your
          {{ sampleType.name }} submission(s)/sample(s).</span
        >
        <span v-else>To fill your sample(s), select a sample type.</span>
      </div>
    </div>
    <slot name="belowTitle"> </slot>
    <div v-if="sampleType">
      <template v-for="submission in submissionList">
        <project-submission-form
          :key="submission.id"
          :submissionId="submission.id"
          :sampleType="sampleType"
          :testPackageGroups="testPackageGroups"
          :serviceQuestions="serviceQuestions"
          :turnarounds="turnarounds"
          :managedLists="managedLists"
        />
      </template>
      <b-button block variant="success" @click.prevent="addSubmission">
        <i class="fa fa-plus" /> Add Submission
      </b-button>
    </div>
  </div>
</template>

<script>
import ProjectSubmissionForm from "../components/ProjectSubmissionForm.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ProjectWizardStep2",
  components: {
    ProjectSubmissionForm
  },
  props: {
    sampleType: {
      type: Object,
      default: () => null
    },
    testPackageGroups: {
      type: Array,
      default: () => []
    },
    serviceQuestions: {
      type: Array,
      default: () => []
    },
    turnarounds: {
      type: Array,
      default: () => []
    },
    managedLists: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      submissionList: "projectFormStepTwo",
      cardInfo: "projectFormStepOne"
    })
  },
  mounted() {
    if (!this.submissionList.length) {
      this.addSubmission();
    }
  },
  methods: {
    ...mapActions(["ADD_NEW_SUBMISSION"]),
    generateDefaultNames(list, name) {
      return list.map((item, index) => {
        if (this.sampleType.name === "Potato") {
          return {
            ...item,
            identifier: `${name} ${index + 1}`,
            test_package_sample_id: this.$uuid.v4(),
            sample_potato: {
              field: null,
              harvest_date: null
            }
          };
        }
        return {
          ...item,
          identifier: `${name} ${index + 1}`,
          test_package_sample_id: this.$uuid.v4()
        };
      });
    },
    addSubmission() {
      if (this.submissionList.length) {
        const lastAddedSubmission = this.submissionList.find(
          (submission, index) => index + 1 === this.submissionList.length
        );
        const newSubmission = JSON.parse(JSON.stringify(lastAddedSubmission));
        if (this.sampleType.name === "Irrigation Suitability") {
          this.ADD_NEW_SUBMISSION({
            ...newSubmission,
            id: this.$uuid.v4(),
            event_code: null,
            identifier: null,
            bore_holes:
              (newSubmission.bore_holes &&
                newSubmission.bore_holes.length &&
                newSubmission.bore_holes.map((boreHole, index) => {
                  return {
                    ...boreHole,
                    bore_hole_id: this.$uuid.v4(),
                    identifier: `Bore Hole ${index + 1}`,
                    samples:
                      (boreHole.samples &&
                        boreHole.samples.length &&
                        this.generateDefaultNames(
                          boreHole.samples,
                          "Sample"
                        )) ||
                      []
                  };
                })) ||
              []
          });
        } else if (this.sampleType.name === "Potato") {
          this.ADD_NEW_SUBMISSION({
            ...newSubmission,
            id: this.$uuid.v4(),
            event_code: null,
            identifier: null,
            submission_potato: {
              grower: null,
              storage_bin: null
            },
            samples:
              (newSubmission.samples &&
                newSubmission.samples.length &&
                this.generateDefaultNames(newSubmission.samples, "Sample")) ||
              []
          });
        } else {
          this.ADD_NEW_SUBMISSION({
            ...newSubmission,
            id: this.$uuid.v4(),
            event_code: null,
            identifier: null,
            samples:
              (newSubmission.samples &&
                newSubmission.samples.length &&
                this.generateDefaultNames(newSubmission.samples, "Sample")) ||
              []
          });
        }
      } else {
        this.ADD_NEW_SUBMISSION({
          id: this.$uuid.v4(),
          test_package_id: null
        });
      }
    }
  }
};
</script>
